import React from 'react';
import PropTypes from 'prop-types';

import styles from './Layout.scss';

export default function Layout(props) {
  const { children, title } = props;
  return (
    <section className={styles.container}>
      <h1 className={styles.header}>{title}</h1>
      <article
        className={styles.body}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    </section>
  );
}

Layout.propTypes = {
  title: PropTypes.string,
};

Layout.defaultProps = {
  title: '',
};



// WEBPACK FOOTER //
// ./src/components/StaticPages/Layout.jsx